//
//
//
//
//
//
//
//
//
//
//
//

  export default {
      computed:{
          styleObject(){
              let style={}
              let {width,height} = this
              style['width'] = width
              style['height']=height
              return style
          },
          slotObject(){
              let style=Object.create(this.slotConfig)
              return style
          }
      },
      props:{
          width:{
              type:String,
              default:'100%'
          },
          height:{
              type:String,
              default:'100%'
          },
          slotConfig:{
              type:Object,
              default(){
                  return {
                      position:'absolute',
                      bottom:'0',
                      left:'0',
                      width:'100%'
                  }
              }
          },
          img:{
              type:String,
              required:true
          }
      },
      data(){
          return {
              loadingText:'',
              imgLoaded:false,
          }
      },
      methods:{
          imgLoad(){
          	  this.$emit('loaded')
              this.imgLoaded=true
          }
      }
  }



// WEBPACK FOOTER //
// ./src/vue-components/img/img.vue